import { render, staticRenderFns } from "./IndexCard.vue?vue&type=template&id=49f82a7c&scoped=true"
import script from "./IndexCard.vue?vue&type=script&lang=js"
export * from "./IndexCard.vue?vue&type=script&lang=js"
import style0 from "./IndexCard.vue?vue&type=style&index=0&id=49f82a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f82a7c",
  null
  
)

export default component.exports